import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { AlertProvider } from "src/components/UI/CustomAlert";
import router from "./routes/main";
import store, { persistor } from "./store";
// import NewsletterPopup from "src/components/common/NewsletterPopup";
import "./App.css";

const App = () => {
  return (
    <Provider store={store}>
      <HelmetProvider>
        <AlertProvider>
          <PersistGate loading={null} persistor={persistor}>
            {(bootstrapped) => (
              <>
                <RouterProvider router={router} />
                {/* <NewsletterPopup /> */}
              </>
            )}
          </PersistGate>
        </AlertProvider>
      </HelmetProvider>
    </Provider>
  );
};

export default App;
